import { useState } from "react";
import { Slider } from "components/ui/slider";
import { Calculator } from "lucide-react";

const CalculatorSection = ({ exchangeData }) => {
  const minValue = 40; // хамгийн бага хэмжээ см
  const [width, setWidth] = useState([minValue]);
  const [height, setHeight] = useState([minValue]);
  const [length, setLength] = useState([minValue]);

  // Эзлэхүүн = см³ → м³
  const volumeM3 = (width[0] * height[0] * length[0]) / 1_000_000;

  const exchangeRate = parseFloat(exchangeData[0]?.exchange) || 0;

  const unitVolume = 0.05; // м³ тутам
  const unitPriceJPY = 800; // ¥
  // const exchangeRate =  520; // 1 ¥ = 520₮

  // Нийт үнэ
  const totalPrice = volumeM3 * unitPriceJPY * exchangeRate;

  const formatMoney = (n) =>
    n.toLocaleString("en-US", { maximumFractionDigits: 0 });

  return (
    <section id="calculator" className="py-20 bg-background w-full">
      <div className="container mx-auto px-4">
        <div className="max-w-lg mx-auto card-elevated p-8 animate-fade-up delay-200">
          <div className="flex items-center gap-3 mb-8">
            <Calculator className="w-8 h-8 text-primary" />
            <span className="text-xl font-semibold text-foreground">
              Хэмжээ оруулах
            </span>
          </div>

          <div className="space-y-8">
            {/* Өргөн */}
            <div>
              <div className="flex justify-between mb-3">
                <label className="text-sm font-medium">Өргөн:</label>
                <span className="text-sm font-bold text-primary">
                  {width[0]} см
                </span>
              </div>
              <Slider
                value={width}
                onValueChange={(val) => setWidth([Math.max(val[0], minValue)])}
                min={minValue}
                max={100}
                step={1}
              />
            </div>

            {/* Өндөр */}
            <div>
              <div className="flex justify-between mb-3">
                <label className="text-sm font-medium">Өндөр:</label>
                <span className="text-sm font-bold text-primary">
                  {height[0]} см
                </span>
              </div>
              <Slider
                value={height}
                onValueChange={(val) => setHeight([Math.max(val[0], minValue)])}
                min={minValue}
                max={100}
                step={1}
              />
            </div>

            {/* Урт */}
            <div>
              <div className="flex justify-between mb-3">
                <label className="text-sm font-medium">Урт:</label>
                <span className="text-sm font-bold text-primary">
                  {length[0]} см
                </span>
              </div>
              <Slider
                value={length}
                onValueChange={(val) => setLength([Math.max(val[0], minValue)])}
                min={minValue}
                max={100}
                step={1}
              />
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-border text-center">
            <span className="text-lg text-muted-foreground">Нийт үнэ: </span>
            <span className="text-3xl font-extrabold text-primary">
              {formatMoney(totalPrice)} ₮
            </span>
            <div className="mt-2 text-sm text-green-700">
              Тухайн бодогдож буй дүн дунджаар бодогдож буй дүн учраас Монголд
              буусны дараа зөрүү гарах боломжтойг анхаарна уу. Нийт бодогдох
              боломжтой хэмжээ 0.05м3-ээс дээш
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CalculatorSection;
